/**
 * Material-UI Theme Configuration
 * 
 * Defines the application's Material-UI theme with custom color palette,
 * component overrides, and styling defaults.
 * 
 * Color Scheme:
 * - Primary: rgb(132, 189, 0) - Green accent color
 * - Background: #f5f5f5 (default), #ffffff (paper)
 * - Text: Inherited from MUI defaults
 */

import { createTheme } from '@mui/material/styles';

/**
 * Application Theme Object
 * 
 * Customizes Material-UI components with consistent styling across the application.
 * 
 * @property {Object} palette - Color palette configuration
 * @property {Object} palette.primary - Primary color settings
 * @property {string} palette.primary.main - Primary green color rgb(132, 189, 0)
 * @property {string} palette.primary.contrastText - White text on primary background
 * @property {Object} palette.background - Background colors
 * @property {string} palette.background.default - Default background #f5f5f5
 * @property {string} palette.background.paper - Paper/card background #ffffff
 * @property {Object} components - Component-specific overrides
 * @property {Object} components.MuiButton - Button component styling
 * @property {Object} components.MuiTextField - TextField component styling
 */
export const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(132, 189, 0)',
      contrastText: '#ffffff'
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: 'none',
          height: 32
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            height: 32
          }
        }
      }
    }
  }
});
